module.exports = __webpack_public_path__ + "static/media/t1.73ba46d6.png";